import type { PopupWindow } from './popupWindow';

const POLL_INTERVAL_MS = 500;

type WaitForPopupClosedParams = {
  signal: AbortSignal;
  intervalMs?: number;
};

export function waitForPopupClosed(
  popup: PopupWindow,
  { signal, intervalMs = POLL_INTERVAL_MS }: WaitForPopupClosedParams
): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    if (signal.aborted) {
      reject(signal.reason);

      return;
    }

    const cleanup = () => {
      clearInterval(interval);
      signal.removeEventListener('abort', onAbort);
    };

    const interval = setInterval(() => {
      if (popup.closed) {
        cleanup();
        resolve();
      }
    }, intervalMs);

    const onAbort = () => {
      cleanup();
      reject(signal.reason);
    };

    signal.addEventListener('abort', onAbort, { once: true });
  });
}
